import React from 'react';
import InsiderIcon from '../components/png/InsiderIcon';
import {connect} from 'react-redux';
import {SSORegister} from '../reducers/skysso';
import {insiderLoginInitiated} from 'modules/Insider/reducers/reducer';
import {INSIDERS_LINK_CLICK_TRACKING_EVENT} from 'modules/Common/consts';
import { trackClick } from 'utils/AnalyticsUtils';
import { MetricsElement } from "react-metrics";
import { Link } from 'react-router';
import PropTypes from 'prop-types';

export function PureInsiderMpu({loggedIn, trackRegister, doRegister}) {
    require("./InsiderMpu.scss");

    const insiderUrl = '/insider';

    const iconProps = {
        title: "Insider Feature"
    }

    const onRegister = () => {
        trackRegister()
        doRegister()
    }

    if (loggedIn) {
        return null;
    }

    return (
        <div className="insider-promo">
            <div className="content">
                <h2 className="strap-line">Know it all.</h2>
                <p><span className="highlighted">Become an <strong>Insider</strong> to unlock</span> 
                <span className="highlighted">loads of exclusive features including:</span>
                </p>
                <ul>
                    <li><InsiderIcon {...iconProps}/> Unlimited video replays</li>
                    <li><InsiderIcon {...iconProps}/> Tips and previews</li>
                    <li><InsiderIcon {...iconProps}/> Live score update notifications</li>
                    <li><InsiderIcon {...iconProps}/> Betting offers and more!</li>                    
                </ul>

                <div className="reglog-button-fw-row">
                    <MetricsElement>
                        <Link to={insiderUrl}
                            {...trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] MPU Learn More"})}
                            className="btn register-button"
                            id="register-btn">Learn more</Link>

                    </MetricsElement>
                    <MetricsElement>
                        <button onClick={onRegister} 
                            className="test btn login-button"
                            {...trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] MPU Join"})}
                            id="login-btn">Join for free</button>
                    </MetricsElement>
                </div>
            </div>
        </div>
    );
}

PureInsiderMpu.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    trackRegister: PropTypes.func.isRequired,
    doRegister: PropTypes.func.isRequired
}

const mapStateToProps = state => {
    return {
        loggedIn: state.common.auth.loggedIn
    }
}

const mapDispatchToProps = dispatch => {
    return {
        trackRegister: () => {
            dispatch(insiderLoginInitiated())
        },
        doRegister: () => {
            dispatch(SSORegister())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PureInsiderMpu);


// WEBPACK FOOTER //
// ./modules/Common/containers/InsiderMpu.js